import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=87f62c68&scoped=true&lang=pug"
import script from "./RememberPassword.vue?vue&type=script&lang=js"
export * from "./RememberPassword.vue?vue&type=script&lang=js"
import style0 from "./RememberPassword.vue?vue&type=style&index=0&id=87f62c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f62c68",
  null
  
)

export default component.exports